import { BaseColumn, DataEntryColumn, EditableGrid, field, Schema } from "../core/components/editableGrid/editableGrid";
import { Helper } from "../core/util/helper";
import { HTTPService } from "../core/util/httpManager";
import React from "react";
export interface EditTranslationsInGridProps {
    id: string,
    translationColumns: DataEntryColumn[]
    gridData: ContainsLanguage[];
    setEntityDirtyState?: (isDirty: boolean) => void;
    onDataLoaded?: () => void;
}

interface Language {
    Language?: number;
    Sprache?: string;
}

export default class EditTranslationsInGrid extends React.Component<EditTranslationsInGridProps, {
    Columns: BaseColumn[];
    Schema: Schema;
    Languages: Language[];
    GridData: Language & ContainsLanguage[];
}>{
    private editableGridRef: EditableGrid;

    constructor(props) {
        super(props);
        this.state = {
            Columns: null,
            Schema: null,
            Languages: [],
            GridData: []
        };
    }

    componentDidMount() {
        this.initColumnsAndSchema();
        this.loadUsedLanguagesAndMapToTranslations();
    }

    private loadUsedLanguagesAndMapToTranslations = async () => {
        let languages = await HTTPService.get<Language[]>("TranslationsView/GetAllLanguages"); //ToDo EK Languages in Config ?

        let gridData: any[] = this.mapLanguagesAndTranslations(languages);

        this.setState({ Languages: languages, GridData: gridData }, () => {
            if (Helper.hasValue(this.props.onDataLoaded))
                this.props.onDataLoaded();
        });
    }

    private mapLanguagesAndTranslations = (languages: Language[]) => {
        let gridData: Language & ContainsLanguage[] = [];
        for (let language of languages) {
            let matchedGridData = this.props.gridData.find(x => x.LangId == language.Language);
            if (matchedGridData == null) {
                matchedGridData = { LangId: language.Language };
                this.props.gridData.push(matchedGridData);
            }
            gridData.push(Object.assign(language, matchedGridData));
        }
        return gridData;
    }

    private initColumnsAndSchema = async () => {
        const languageIdName: string = "Language";
        const languageColumnName: string = "Sprache";

        let columns: BaseColumn[] = [];

        let languageColumn: DataEntryColumn = this.getColumn(Helper.getTranslation("Sprachen.Sprache"), "100", languageColumnName, () => false);
        columns.push(languageColumn);

        let schema = new Schema();
        schema.Id = languageIdName;
        schema.fields[languageIdName] = new field("number");
        schema.fields[languageColumnName] = new field("string");

        for (let translationColumn of this.props.translationColumns) {
            if (!Helper.hasValue(translationColumn.editable))
                translationColumn.editable = (_) => true;
            let column = this.getColumn(translationColumn.title, translationColumn.width, translationColumn.field, translationColumn.editable);
            column.multiLine = translationColumn.multiLine;
            column.multiLines = translationColumn.multiLines;
            columns.push(column);
            schema.fields[translationColumn.field] = new field("string");
        }

        this.setState({ Columns: columns, Schema: schema });
    }

    private getColumn = (title: string, width: string, fieldName: string, editable: (_) => boolean) => {
        let column: DataEntryColumn = new DataEntryColumn();
        column.title = title;
        column.width = width;
        column.field = fieldName;
        column.editable = editable;

        return column;
    }

    public markAsSaved = () => {
        this.editableGridRef.getDataSource().sync();
    }

    private handleFieldChange = (e) => {
        let changedPropertyNames = Object.getOwnPropertyNames(e.values);

        for (let changedPropertyName of changedPropertyNames) {
            let translation = this.props.gridData.find(x => x.LangId == e.model.Language);
            translation[changedPropertyName] = e.values[changedPropertyName];
        }
    }

    private createInGrid = () => {
        return <EditableGrid
            id={this.props.id}
            columns={this.state.Columns}
            schema={this.state.Schema}
            data={this.state.GridData}
            selectable={false}
            showSelectableCheckBox={false}
            validatable={false}
            groupable={false}
            editable={true}
            onDataChanged={() => {
                if (Helper.hasValue(this.props.setEntityDirtyState)) {
                    this.props.setEntityDirtyState(true)
                }
            }}
            onFieldChanged={(e) => this.handleFieldChange(e)}
            ref={(ref) => this.editableGridRef = ref} />
    }

    render() {
        let grid = Helper.hasValue(this.state.Columns) && Helper.hasValue(this.state.Schema) ? this.createInGrid() : null;
        return (<>
            {grid}
        </>);
    }
}
export interface ContainsLanguage {
    LangId?: number;
}

export interface UebersetungInGrid extends ContainsLanguage {
    Value0?: string;
    Value1?: string;
    ValueText0?: string;
}